































import { Component, Mixins, Vue, Ref } from 'vue-property-decorator'
import InputSimple from '@/components/common/atoms/InputSimple.vue'
import SelectBase from '@/components/common/atoms/SelectBase.vue'
import ButtonBase from '@/components/common/atoms/ButtonBase.vue'
import FileDropArea from '@/components/common/atoms/FileDropArea.vue'
import LinkArea from '@/components/branch/organisms/LinkArea.vue'
import StudentTable from '@/components/branch/organisms/StudentTable.vue'
import StudentListApis, { StudentData, StudentSearchQuery } from '@/mixins/requests/branch/StudentListApis.vue'
import PaginationButton from '@/components/common/organisms/PaginationButton.vue'

@Component({
  components: {
    InputSimple,
    SelectBase,
    ButtonBase,
    StudentTable,
    FileDropArea,
    LinkArea,
    PaginationButton,
  },
})
export default class StudentList extends Mixins(StudentListApis) {
  private bcbtCode = ''
  private gradeId = ''
  private nickname = ''
  private status = ''
  private currentQuery: StudentSearchQuery = {}

  private studentList: StudentData[] = []

  private gradeOptions = []

  // ref: ページネーション
  @Ref() paginationButton!: PaginationButton

  private async mounted() {
    // TODO：検索条件の復元
    Vue.prototype.$loading.start()
    try {
      this.gradeOptions = await this.loadGrades()
      this.search()
    } finally {
      Vue.prototype.$loading.complete()
    }
  }

  private async onDrop(file: File) {
    // 取込処理
    if (confirm('取込を開始しますがよろしいですか？')) {
      Vue.prototype.$loading.start()
      try {
        await this.importExcel(file)
        alert('取込みが完了しました')
      } catch (e) {
        if (e.response.data.status === 400) {
          alert(e.response.data.message.message)
        } else {
          alert('取込中にエラーが発生しました')
        }
      } finally {
        await this.loadStudents()
        Vue.prototype.$loading.complete()
      }
    }
  }

  private onClickSearch() {
    Vue.prototype.$loading.start()
    try {
      this.search()
    } finally {
      Vue.prototype.$loading.complete()
    }
  }

  private async search() {
    this.currentQuery = {}
    if (this.bcbtCode) {
      this.currentQuery.bcbtCode = this.bcbtCode
    }
    if (this.gradeId) {
      this.currentQuery.gradeId = this.gradeId
    }
    if (this.nickname) {
      this.currentQuery.nickname = this.nickname
    }
    if (this.status) {
      this.currentQuery.status = this.status
    }

    await this.loadStudents()
  }

  private async onClickExport() {
    Vue.prototype.$loading.start()
    try {
      const exportInfo = await this.exportExcel(this.currentQuery)
      const fileLink = document.createElement('a')
      fileLink.href = exportInfo.url
      fileLink.download = exportInfo.filename
      fileLink.click()
    } finally {
      Vue.prototype.$loading.complete()
    }
  }

  private onClickComfirmButton(bcbtCode: string) {
    // 受験履歴画面へ遷移
    this.$router.push({ name: 'BranchHistoryByStudent', params: { bcbtCode: bcbtCode } })
  }

  private async loadStudents() {
    const studentObject = await this.searchStudents(this.paginationButton.paginationCurrentPage, this.currentQuery)
    this.studentList = studentObject.responses
    this.paginationButton.paging(studentObject.pagination)
  }

  private async onClickPaginationButton() {
    await this.search()
  }
}
